/**
 * Which GoatCounter site, if any, counts the page views on a given host.
 *
 * Production and staging count into separate GoatCounter sites, so testing on
 * staging never inflates the real numbers. Any other host (localhost, a
 * preview build) counts nowhere and does not load the script at all.
 */

/** GoatCounter's counting script, pinned to a version so its hash holds. */
export const GOATCOUNTER_SCRIPT = {
  src: 'https://gc.zgo.at/count.v4.js',
  integrity: 'sha384-nRw6qfbWyJha9LhsOtSb2YJDyZdKvvCFh0fJYlkquSFjUxp9FVNugbfy8q1jdxI+',
} as const;

/**
 * Host → GoatCounter site code (the `<code>` in `<code>.goatcounter.com`).
 * The codes are random on purpose: anyone can read them in the page source,
 * so they must not name the gallery or tie staging to production.
 */
const SITE_CODES: Readonly<Record<string, string>> = {
  'kumargallery.com': 'ccibc6cu6t',
  'www.kumargallery.com': 'ccibc6cu6t',
  'staging.kumargallery.com': 'hsmt6bcgqa',
};

/** The URL that page views on `hostname` are sent to, or null to send none. */
export const goatCounterEndpoint = (hostname: string): string | null => {
  const code = SITE_CODES[hostname.toLowerCase()];
  return code ? `https://${code}.goatcounter.com/count` : null;
};

/**
 * The path a page view is recorded under. The query string is left off so
 * `?fbclid=…` and similar tags don't split one page into many; GoatCounter
 * still reads `?ref=` and `?utm_source=` from the address bar as the referrer.
 */
export const pageViewPath = ({ pathname }: Pick<Location, 'pathname'>): string => pathname;
